import { useLayoutEffect, useState } from 'react';

function usePartialState(initialState) {
    const [nextChange, setNextChange] = useState(null);
    const [state, setState] = useState(initialState);
    const partialStateChanges = {};
    let nextChangeData = nextChange || {};

    useLayoutEffect(() => {
        setState(Object.assign({}, state, nextChange));
        setNextChange(null);
    }, [nextChange]);

    return [
        state,
        function setPartialState(partialStateUpdate) {
            Object.assign(partialStateChanges, partialStateUpdate);
            nextChangeData = Object.assign(nextChangeData, partialStateChanges);
            setNextChange(nextChangeData);
        },
        function overridePartialState(newState) {
            return setState(newState);
        },
    ];
}

export default usePartialState;
